import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SubmissionStateEnum } from '../../../../../models/users/enum/submission-state-enum';

@Component({
  selector: 'app-submission-detail',
  templateUrl: './submission-detail.component.html',
  styleUrls: ['./submission-detail.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmissionDetailComponent {
  @Input() label: string = '';
  @Input() value: string | number = '';
  @Input() hasChanged: boolean = false;
  @Input() submissionState!: SubmissionStateEnum;
}
